import Vue from "vue";
import VueRouter from "vue-router";
import nichiboSalesContacts from "./components/SiteSettings/NichiboSalesContacts";

const search = require('./components/VehicleSearch.vue');
const search_results_page = require('./components/SeachListPage.vue');
const single_vehicle_page =  require('./components/SingleVehicle.vue')
const notifications_page =  require('./components/NotificationsPage.vue')
const myGarage = require('./components/MyGarage/MyGaragePage')
const stockSingle = require('./components/VehicleStock/ShowPage')
const layout = require('./components/Layouts/DefaultLayout')
const urlUpdateLayout = require('./components/Layouts/UrlUpdateLayout')
const publicStock = require('./components/VehicleStock/PublicStock')
const unsoldsStock = require('./components/VehicleStock/UnsoldsStock')
const globalStock = require('./components/VehicleStock/GlobalStock')
const purchasedStock = require('./components/VehicleStock/PurchasedStock')
const settingsPage = require('./components/Admin/SettingsPage')
const auctionSitesPage = require('./components/AuctionSitesPage')
const settings = require('./components/Forms/Settings')
const fees = require('./components/Forms/FeesPage')
const offerFees = require('./components/Forms/OfferFeesPage')
const marketResearchParameters = require('./components/SiteSettings/MarketResearchParameters')
const termsAndConditions = require('./components/SiteSettings/TermsAndConditions')
const bidSettings = require('./components/SiteSettings/BidSettings.vue')
const page404 = require('./components/404page')
const userStockList = require('./components/User/StockListDate')
const login = require('./components/Auth/Login')
const resetPassword = require('./components/Auth/ResetPassword')
const forgotPassword = require('./components/Auth/ForgotPassword')
const userListPage = require('./components/User/UserListPage')
const userShow = require('./components/User/ShowUser')
const usersEdit = require('./components/User/EditUser')
const autonotices = require('./components/AutoNotices/List')
const companies = require('./components/Companies/List')
const EditCompanyPage = require('./components/Companies/EditCompanyPage')
const CreateCompanyPage = require('./components/Companies/CreateCompanyPage')
const ShowCompanyPage = require('./components/Companies/ShowCompany')
const recommended = require('./components/MyRecommendations/RecommendedPage')
const favourites = require('./components/Favourites/FavouritesPage.vue')
const bidsListPage = require('./components/BidsListPage.vue')
const dashboardPage = require('./components/DashboardPage.vue')
const savedSearch = require('./components/SavedSearch/SavedSearch.vue')
const marketResearch = require('./components/Forms/MarketResearch.vue')
const marketResearchResults = require('./components/MarketResearchList.vue')
const viewedVehiclesPage = require('./components/VehicleViewsPage.vue')
const acceptTermsPage = require('./components/User/AcceptTermsPage')
const acceptUpdatedTermsPage = require('./components/User/AcceptUpdatedTermsPage')
const autoEmail = require('./components/SiteSettings/AutoEmail')
//make sure there's a name and that's it's the same as laravel.
const routes = [
    {
        path: '/',
        component: layout,
        children: [
            {
                path: '',
                name: 'dashboard',
                meta: {title: 'Dashboard'},
                component: dashboardPage
            },
        ]
    },
    {
        path: '/auctions',
        component: layout,
        children: [
            {
                path: '',
                name: 'auction',
                meta: {title: 'Auction search'},
                component: search
            },
            {
                path: 'market-research',
                name: 'market-research',
                meta: {title: 'Market Research'},
                component: marketResearch,
            },
            {
                path: 'market-research-results',
                name: 'market-research-results',
                meta: {title: 'Market Research Results'},
                component: marketResearchResults,
                props: (route) => ({
                    'searchfields': route.query
                }),

            },
        ]
    },
    {
        path: '/companies',
        component: layout,
        children: [
            {
                path: '',
                name: 'list',
                meta: {title: 'Companies'},
                component: companies
            },
            {
                path: 'create',
                name: 'create',
                meta: {title: 'Create Company'},
                component: CreateCompanyPage,
            },
            {
                path: ':id',
                name: 'show',
                meta: {title: 'View Company'},
                component: ShowCompanyPage,
                props: (route) => ({
                    'company_id': route.params.id
                }),
            },
            {
                path: ':id/edit',
                name: 'edit',
                meta: {title: 'Edit Company'},
                component: EditCompanyPage,
                props: (route) => ({
                    'company_id': route.params.id
                }),
            },
        ]
    },
    {
        path: '/claims',
        component: layout,
        children: [
            {
                path: '',
                name: 'claims-dashboard',
                meta: {title: 'Claims'},
                component: require('./components/Claims/List.vue')
            },
            {
                path: 'create',
                name: 'claims-create',
                meta: {title: 'Create Claim'},
                component: require('./components/Claims/CreateClaimPage.vue'),
            },
            {
                path: ':id',
                name: 'claims-show',
                meta: {title: 'View Claim'},
                component: require('./components/Claims/ShowClaim.vue'),
                props: (route) => ({
                    'claim_id': route.params.id
                }),
            },
            {
                path: ':id/edit',
                name: 'claims-edit',
                meta: {title: 'Edit Claim'},
                component: require('./components/Claims/EditClaimPage.vue'),
                props: (route) => ({
                    'claim_id': route.params.id
                }),
            },
        ]
    },
    {
        path: '/user-bid',
        component: layout,
        children: [
            {
                path: '',
                name: 'user-bid',
                meta: {title: 'Bids'},
                component: bidsListPage
            },
        ]
    },
    {
        path: '/auth',
        component: layout,
        children: [
            {
                path: 're-login',
                name: 're-login',
                meta: {title: 'Login'},
                component: login
            },
            {
                path: 'forgot-password',
                name: 'forgot-password',
                meta: {title: 'Forgot Password'},
                component: forgotPassword
            },
            {
                path: 'request-password-reset',
                name: 'request-password-reset',
                meta: {title: 'Reuqest Password Reset'},
                component: resetPassword
            },
        ]
    },
    {
        path: '/login',
        component: layout,
        children: [
            {
                path: '',
                name: 'login',
                meta: {title: 'Login'},
                component: login
            },
        ]
    },
    {
        path: '/saved-search',
        component: layout,
        children: [
            {
                path: '',
                name: 'saved-search',
                meta: {title: 'Saved Search'},
                component: savedSearch
            },
        ]
    },
    {
        path: '/auto-notices',
        component: layout,
        children: [
            {
                path: '',
                name: 'autonotice',
                meta: {title: 'Auto notices'},
                component: autonotices
            },
            {
                path: ':id/edit',
                name: 'autonotice.edit',
                meta: {title: 'Auto notices'},
                component: autonotices,
            },
        ]
    },
    {
        name: 'search-vehicle',
        path: '/auctions/search',
        meta: {title: 'Auction search results'},
        component: search_results_page,
        props: (route) => ({
            'searchfields': route.query,
            past: route.query.hasOwnProperty('past_auction_date') ? 1 : 0
        }),
    },
    {
        path: '/vehicle-view',
        component: layout,
        children: [
            {
                path: '',
                name: 'vehicle-view.index',
                meta: {title: 'Viewed Vehicles'},
                component: viewedVehiclesPage,
            }
        ]
    },
    {
        path: '/search/:id',
        component: urlUpdateLayout,
        children: [
            {
                path: '',
                name: 'vehicle-detail',
                component: single_vehicle_page,
                props: (route) => ({'vid': route.params.id})
            }
        ]
    },
    {
        name: 'notifications',
        path: '/notifications/:type',
        component: notifications_page,
        props: (route) => ({ 'type': route.params.type })
    },
    {
        path: '/accept-terms',
        component: layout,
        children: [
            {
                path: '',
                name: 'accept-terms',
                component: acceptTermsPage,
            }
        ]
    },
    {
        path: '/accept-updated-terms',
        component: layout,
        children: [
            {
                path: '',
                name: 'accept-updated-terms',
                component: acceptUpdatedTermsPage,
            }
        ]
    },
    {
        path: '/vehicle-stock/',
        component: layout,
        children: [
            {
                path: '',
                component: myGarage
            },
            {
                path: 'my-garage',
                component: myGarage
            },
            {
                path: 'public',
                component: publicStock
            },
            {
                path: 'unsolds',
                component: unsoldsStock
            },
            {
                path: 'global',
                component: globalStock
            },
            {
                path: 'purchases',
                component: purchasedStock
            },
            {
                path: ':id',
                component: stockSingle,
                props: (route) => ({'vehicle_stock_id': route.params.id}),
                meta: {updateOnUrl: true}
            },
        ]
    },
    {
        path: '/settings/',
        component: settingsPage,
        children: [
            {
                path: '',
                component: settings
            },
            {
                path: 'fees',
                component: fees,
                props: (route) => ({ 'type': route.params.type })
            },
            {
                path: 'offer-fees',
                component: offerFees,
                props: (route) => ({ 'type': route.params.type })
            },
        ]
    },
    {
        path: '/manage/site-settings/',
        component: layout,
        children: [
            {
                path: 'market-research',
                component: marketResearchParameters,
            },
            {
                path: 'terms-and-conditions',
                component: termsAndConditions,
            },
            {
                path: 'bid-settings',
                component: bidSettings,
            },
            {
                path: 'nichibo-sales-contacts',
                component: nichiboSalesContacts,
            },
            {
                path: 'auto-email',
                component: autoEmail,
            },
        ]
    },
    {
        path: '/auction-sites',
        component: layout,
        children: [
            {
                path: '',
                component: auctionSitesPage
            },
        ]
    },
    {
        path: '/users',
        component: layout,
        children: [
            {
                path: '',
                component: userListPage
            },
            {
                path: ':id/stock-list-dates',
                component: userStockList
            },
            {
                path: ':id',
                component: userShow,
                props: (route) => ({ user_id: route.params.id })
            },
            {
                path: ':id/edit',
                component: usersEdit,
                props: (route) => ({ user_id: route.params.id })
            },
        ]
    },
    {
        path: '/co2-emissions',
        component: layout,
        children: [
            {
                path: '',
                name: 'co2-emissions.index',
                meta: {title: 'CO2 Emissions'},
                component: require('./components/Co2Emissions/List.vue')
            },
            {
                path: 'import',
                name: 'co2-emissions.import',
                meta: {title: 'Import CO2 Emissions'},
                component: require('./components/Co2Emissions/Import.vue')
            }
        ]
    },
    {
        name: 'recommended',
        path: '/recommended',
        component: recommended,
    },
    {
        name: 'favourites',
        path: '/favourites',
        component: favourites,
    },
    {
        name: '404',
        path: '*',
        component: page404
    }
];
Vue.use(VueRouter)
const router = new VueRouter({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        let position = savedPosition || {x: 0, y: 0};
        router.lastScrollPosition = position;
        return position;
    },
});
router.lastScrollPosition = {x: 0, y: 0};
export default router



// WEBPACK FOOTER //
// ./resources/js/router.js